module.exports = __webpack_public_path__ + "static/media/madfit-7.0a6362ae.jpg";